/**
 * 4-step tour for actors. The selectors target `data-tour="…"` attributes on
 * existing recording-route elements (BigRecordButton, RefVoiceFader,
 * ScriptPanel) — see the surgical edits in the matching feature files.
 *
 * The tour is intentionally short. From legal to "ready to record" should
 * take under 30 seconds — first impressions matter and actors are the
 * least-tech-savvy persona on the platform.
 */
import type { TourStep } from '../TourStep'

export const ACTOR_TOUR: readonly TourStep[] = [
  {
    id: 'actor-welcome',
    title: 'Welcome to OHEAR.AI',
    body: "Let's record your first take. Four short steps, about 30 seconds.",
  },
  {
    id: 'actor-record-button',
    selector: '[data-tour="record-button"]',
    title: 'Your record button',
    body: 'Press it (or hit Enter) to start recording. A 3-pop streamer plays as a count-in so you can hit your mark.',
    placement: 'top',
  },
  {
    id: 'actor-ref-fader',
    selector: '[data-tour="ref-fader"]',
    title: 'Reference voice fader',
    body: "Adjust how loud you hear the original AI guide voice. Mute it (🔇) before recording for the cleanest take — most pros leave it muted once they've memorized the line.",
    placement: 'bottom',
  },
  {
    id: 'actor-script-panel',
    selector: '[data-tour="script-panel"]',
    title: 'Your script',
    body: 'Your lines are highlighted in blue. Click any line to jump to it. Press G to record an entire scene at once.',
    placement: 'left',
  },
] as const
